import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import { getArticleType } from "scmp-app/components/article/article-render/helpers";
import { usePlusDetailedListingPopup } from "scmp-app/components/plus/detailed-listing-popup/hooks";
import type { plusArticleTypeTitleContent$key } from "scmp-app/queries/__generated__/plusArticleTypeTitleContent.graphql";

import { DataMap } from "./consts";
import { Link, Title } from "./styles";

export type Props = {
  className?: string;
  reference: plusArticleTypeTitleContent$key;
};

export const PlusArticleTypeTitle: FunctionComponent<Props> = ({ className, reference }) => {
  const content = useFragment(
    graphql`
      fragment plusArticleTypeTitleContent on Content {
        ...helpersGetArticleTypeArticle
      }
    `,
    reference,
  );

  const articleTypeId = getArticleType(content) ?? "";
  const { title, type } = DataMap[articleTypeId] ?? {};
  const { handleOpen } = usePlusDetailedListingPopup();
  if (!notEmpty(title)) return null;

  if (type === "infographic") {
    return <Title>{title}</Title>;
  }
  return (
    <Link
      className={className}
      onClick={() =>
        handleOpen({
          type,
        })
      }
    >
      {title}
    </Link>
  );
};

PlusArticleTypeTitle.displayName = "PlusArticleTypeTitle";
